export const FALLBACK_ORCHESTRATOR_HOST = 'https://api.lemanapro.ru';

export function getOrigin(url = ''): string {
  try {
    return new URL(url).origin;
  } catch {
    return FALLBACK_ORCHESTRATOR_HOST;
  }
}
